import { ApiAdresseRoutageFacture, ApiInvoiceReferences } from './api/billing';
import { PRICE_TYPE } from './price';

export type FormFieldName = 'postalCode' | 'city' | 'streetName' | 'streetNumber';

export enum FormSteps {
    POSTAL_CODE_CITY = 1,
    STREET_NAME,
    STREET_NUMBER,
}

export type GoogleMapsSerializedAddress = {
    formatted_address: string;
    locality: string;
    postal_code: string;
    route: string;
    street_number: string;
};

export type GoogleMapsAddressResponse = {
    address: CustomerAddress;
    formattedAddress: string;
};

export type ShippingAddressPayload = {
    adresse: {
        ville: string;
        codePostal: string;
        rue: string;
        numeroRue?: string;
        complementAdresse?: string;
        nom?: string | null;
        prenom?: string | null;
        civilite: string;
    };
    modeLivraison: {
        gencode: string;
    };
    controleAutoGCP: boolean;
};

export type BillingAddressPayload = {
    ville: string;
    codePostal: string;
    rue: string;
    numeroRue?: string;
    complementAdresse?: string;
    controleAutoGCP: boolean;
    adresseRoutageFacture?: ApiAdresseRoutageFacture;
    facture?: ApiInvoiceReferences;
};

export type CustomerAddress = {
    postalCode: string;
    city: string;
    streetName: string;
    streetNumber: string;
    isVerified: boolean;
    complementaryAddress?: string;
};

export type FormState = {
    step: FormSteps;
    inseeCode: string;
    postalCode: string;
    city: string;
    streetNumber: string;
    streetName: string;
    streetId: string;
};

type FieldProps = {
    name: FormFieldName;
    value: string;
    isTouched: boolean;
    isSelectedFromAutocomplete: boolean;
    status: 'success' | 'error' | 'default';
    errorMessage: string;
};

export type FormFields = {
    postalCode: FieldProps & {
        data: PostalCodeAndCityItem[];
    };
    city: FieldProps & {
        data: PostalCodeAndCityItem[];
    };
    streetName: FieldProps & {
        data: StreetNameItem[];
    };
    streetNumber: FieldProps & {
        data: StreetNumberItem[];
    };
};

export type GMAddressField = {
    value: string;
    data: GoogleMapsAutocompleteItem[];
    isSelectedFromAutocomplete: boolean;
    status: 'success' | 'error' | 'default';
    errorMessage: string;
};

export type GoogleMapsAutocompleteItem = {
    data: {
        place_id: string;
    };
    label: string;
};

export type PostalCodeAndCityItem = {
    step: FormSteps.POSTAL_CODE_CITY;
    data: {
        postalCode: string;
        city: string;
        inseeCode: string;
        locality?: string;
    };
    label: string;
};

export type StreetNameItem = {
    step: FormSteps.STREET_NAME;
    data: {
        streetId: string;
        streetName: string;
    };
    label: string;
};

export type StreetNumberItem = {
    step: FormSteps.STREET_NUMBER;
    data: {
        number: string;
    };
    label: string;
};

export type AutocompleteItem = PostalCodeAndCityItem | StreetNameItem | StreetNumberItem;
export type FormData = PostalCodeAndCityItem[] | StreetNameItem[] | StreetNumberItem[];

export type DeliveryAvailableResponse = {
    adresse: {
        city: string;
        postalCode: string;
        streetName: string;
        streetNumber: string;
        isVerified: boolean;
        isGcpValidated: boolean;
    };
    panier: {
        parcours: {
            type: string;
            idVirtuel: number;
            modesLivraison: {
                gencode: string;
                libelle: string;
                dateLivraisonEstimee: string;
                dateLivraisonEstimeeAuPlusTard: string;
                prix: number;
                typePrix: string;
                heureLimite: string;
                produits: {
                    gencode: string;
                    idVirtuel: number;
                }[];
            }[];
        }[];
    };
};

export type DeliveryModeMapped = {
    gencode: string;
    label: string;
    estimatedDeliveryDate: string;
    latestEstimatedDeliveryDate: string;
    price: number;
    priceType: PRICE_TYPE;
    estimatedHour: string;
    products: {
        gencode: string;
        virtualId: number;
    }[];
};
